import React from 'react';
import { Calendar, User, Phone, MapPin } from 'lucide-react';
import { getStatusColors } from '../../../utils/statusUtils';

const LeadPipeline = ({ leads, onView, statuses }) => {
  
  // Create dynamic stages with default colors based on the statuses prop
  const STAGES = statuses && statuses.length > 0 
    ? statuses.map((s, index) => {
        const colors = ['blue', 'indigo', 'amber', 'orange', 'emerald', 'teal', 'rose'];
        return {
          id: s.name,
          title: s.name,
          color: colors[index % colors.length]
        };
      })
    : [
        { id: 'New', title: 'New Leads', color: 'blue' },
        { id: 'Initial Contact', title: 'Contacted', color: 'indigo' },
        { id: 'Negotiation', title: 'Negotiation', color: 'amber' },
        { id: 'Follow up', title: 'Follow Up', color: 'orange' },
      ];

  // Group leads by status
  const leadsByStage = STAGES.reduce((acc, stage) => {
    acc[stage.id] = leads.filter(lead => lead.status === stage.id);
    return acc;
  }, {});

  return (
    <div style={{ display: 'flex', gap: '1.5rem', overflowX: 'auto', paddingBottom: '1rem', minHeight: '600px', marginTop: 15 }} className="show-horizontal-scrollbar">
      {STAGES.map(stage => {
        const stageLeads = leadsByStage[stage.id] || [];
        const stageColors = getStatusColors(stage.title);
        
        return (
          <div key={stage.id} style={{ 
            minWidth: '320px', 
            maxWidth: '320px',
            backgroundColor: 'rgba(241, 245, 249, 0.5)', 
            borderRadius: '12px',
            display: 'flex',
            flexDirection: 'column',
            border: '1px dashed var(--color-border)'
          }}>
            {/* Column Header */}
            <div style={{ padding: '1rem', borderBottom: '1px solid rgba(0,0,0,0.05)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 className="font-semibold text-main" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div style={{ 
                  width: '10px', 
                  height: '10px', 
                  borderRadius: '50%', 
                  backgroundColor: stageColors.dot
                }} />
                {stage.title}
              </h3>
              <span style={{ backgroundColor: 'white', padding: '2px 8px', borderRadius: '12px', fontSize: '0.75rem', fontWeight: 'bold', border: '1px solid var(--color-border)' }}>
                {stageLeads.length}
              </span>
            </div>
            
            {/* Column Cards */}
            <div style={{ padding: '1rem', display: 'flex', flexDirection: 'column', gap: '1rem', flex: 1, overflowY: 'auto' }} className="hide-scrollbar">
              {stageLeads.map(lead => (
                  <div 
                    key={lead.id} 
                    style={{ 
                      backgroundColor: 'white', 
                      borderRadius: '10px', 
                      padding: '1rem', 
                      boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                      border: '1px solid var(--color-border)',
                      cursor: 'pointer',
                      transition: 'transform 0.2s, box-shadow 0.2s'
                    }}
                    onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.05)'; }}
                    onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.05)'; }}
                    onClick={() => onView(lead)}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '0.5rem' }}>
                      <span style={{ fontSize: '0.75rem', color: 'var(--color-text-muted)', fontWeight: '600' }}>#{lead.id}</span>
                    </div>
                    
                    <h4 className="font-bold text-main" style={{ marginBottom: '0.25rem' }}>{lead.name}</h4>
                    <p style={{ fontSize: '0.875rem', color: 'var(--color-text-muted)', marginBottom: '1rem' }}>{lead.machine}</p>
                    
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', borderTop: '1px dashed var(--color-border)', paddingTop: '0.75rem' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.75rem', color: 'var(--color-text-muted)' }}>
                        <User size={12} /> {lead.contact}
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.75rem', color: 'var(--color-text-muted)' }}>
                        <Phone size={12} /> {lead.phone}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default LeadPipeline;
